import React from 'react';

import { useLocalizationContext } from '@order/Localization';

import type { AccountMenuVariant } from '../../AccountMenu.types';
import { useAccountLinks } from '../../hooks';
import { AccountContactUsOption } from '../AccountContactUsOption';
import { AccountMenuSecondaryItem } from '../AccountMenuSecondaryItem';
import { AccountSection } from '../AccountSection';

export const AccountSecondaryMenu = (props: AccountSecondaryMenuProps) => {
  const { variant } = props;

  const { t } = useLocalizationContext();

  const accountLinks = useAccountLinks();

  return (
    <AccountSection variant={variant}>
      <AccountContactUsOption isSecondaryMenuVisible={true} />
      <AccountMenuSecondaryItem
        testID="account-menu.secondary-item.terms"
        label={t('account.sidebar.terms')}
        onPress={accountLinks.handleTermsLink}
      />
      <AccountMenuSecondaryItem
        testID="account-menu.secondary-item.privacy-policy"
        label={t('account.sidebar.privacy-policy')}
        onPress={accountLinks.handlePrivacyLink}
      />
      <AccountMenuSecondaryItem
        testID="account-menu.secondary-item.do-not-sell"
        label={t('account.sidebar.do-not-sell')}
        onPress={accountLinks.handlePersonalInfoLink}
      />
    </AccountSection>
  );
};

type AccountSecondaryMenuProps = {
  readonly variant: AccountMenuVariant;
};
